<template>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        :disabled="isFetch || errorState"
    >
        <v-row>
            <v-col cols="12">
                <jur-prefetch v-if="isShowJurPrefetch" @result="onPrefetchResult"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                  v-model="form.inn"
                  label="ИНН"
                  :error-messages="errorMessages.inn"
                  required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                  v-model="form.ogrn"
                  label="ОГРН"
                  :error-messages="errorMessages.ogrn"
                  required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                  v-model="form.kpp"
                  :error-messages="errorMessages.kpp"
                  label="КПП"
                  required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-text-field
                        v-model="form.full_name"
                        :error-messages="errorMessages.full_name"
                        label="Полное наименование"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                        v-model="form.short_name"
                        :error-messages="errorMessages.short_name"
                        label="Сокращенное наименование"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                        v-model="form.legal_address"
                        :error-messages="errorMessages.legal_address"
                        label="Юридический адрес"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                        v-model="form.actual_address"
                        :error-messages="errorMessages.actual_address"
                        label="Фактический адрес"
                        required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-text-field
                        v-model="form.director_position"
                        :error-messages="errorMessages.director_position"
                        label="Должность директора"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                        v-model="form.director_name"
                        :error-messages="errorMessages.director_name"
                        label="Имя директора"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                        v-model="form.director_patronymic"
                        :error-messages="errorMessages.director_patronymic"
                        label="Отчество директора"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                        v-model="form.director_surname"
                        :error-messages="errorMessages.director_surname"
                        label="Фамилия директора"
                        required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn
                    :disabled="isFetch || errorState"
                    color="success"
                    class="mr-4"
                    @click="onSave"
                >
                    Сохранить
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import JurPrefetch from "./JurPrefetch.vue";
export default {
    name: "JurForm",
    components: {JurPrefetch},
    props:{
        initIsShowJurPrefetch: {
            type: Boolean,
            default: true,
        },
        initJurId: {
            type: Number,
            default: null,
            required: false
        },
        initForm: {
            type: Object,
            default: function () {
                return {
                    inn: '',
                    ogrn: '',
                    kpp: '',
                    full_name: '',
                    short_name: '',
                    legal_address: '',
                    actual_address: '',
                    director_position: '',
                    director_name: '',
                    director_patronymic: '',
                    director_surname: '',
                };
            },
            required: false
        }
    },
    mounted() {
        this.jurId = this.initJurId;
        this.setFormFields(this.initForm);
    },
    data(){
        return {
            errorState: false,
            jurId: null,
            isFetch: false,
            valid: true,
            form: {
              inn: null,
              ogrn: null,
              kpp: null,
              full_name: null,
              short_name: null,
              legal_address: null,
              actual_address: null,
              director_position: null,
              director_name: null,
              director_patronymic: null,
              director_surname: null,
            },
            errorMessages: {}
        }
    },
    watch: {
        jurId(newVal){
            if(newVal){
                this.loadJur(newVal);
            }
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        async loadJur(jurId){
            try {
                this.isFetch = true;
                let {data} = await this.getClient().getJurInn(jurId);
                this.setFormFields(data);
            }catch (e){
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Не удалось загрузить юр лицо ('});
                this.errorState = true;
            }finally {
                this.isFetch = false;
            }
        },
        async onSave(){
            try {
                this.isFetch = true;
                this.setErrorMessages({});
                if(this.jurId){
                    await this.update();
                }else {
                    await this.create();
                }
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка ('});
                if(e.response && e.response.data && e.response.data.errors){
                    this.setErrorMessages(e.response.data.errors);
                }

            }finally {
                this.isFetch = false;
            }
        },
        setErrorMessages(errorMessages){
            this.errorMessages = Object.assign({}, {}, errorMessages);
        },
        setFormFields(form){
            for (let k in form){
                if(k in this.form){
                    this.form[k] = form[k];
                }
            }
        },
        async create(){
            let {data} = await this.getClient().jurCreate(this.form);
            this.$emit('created', data);
            this.jurId = data.id;
            this.setFormFields(data);
            this.SHOW_SUCCESS('Успешно создано');
        },
        async update(){
            let {data} = await this.getClient().jurUpdate(this.jurId, this.form);
            this.setFormFields(data);
            this.$emit('updated', data);
            this.SHOW_SUCCESS('Успешно обновлено');
        },
        onPrefetchResult(result){
            this.setFormFields(result);
        }
    },
    computed: {
        ...mapGetters( 'contragents', ['getClient']),
        isShowJurPrefetch(){
            return this.initIsShowJurPrefetch;
        }
    }
}
</script>

<style scoped>

</style>